import { useMemo } from "react";
import ILeaseComp from "../interfaces/ILeaseComp";
import Shape from "../interfaces/Shape";
import GeometryService from "../services/geometryService";

export default function (leaseComps: ILeaseComp[], shape: Shape | Shape[] | null): ILeaseComp[] {
    const geometryService = useMemo(() => new GeometryService(), []);

    return useMemo(() => shape ? leaseComps.filter(lc => geometryService.isPointInsideShape(lc.centerPoint, shape)) : leaseComps, [leaseComps, shape]);
}